module.exports = __webpack_public_path__ + "img/LOGOPARON 2023.a143e696.png";